export class Sheet {
  grade: number | null = 0
  name: string = ""
  curriculum_id: number | null = 0
  question_image_completed: boolean | null = null
}
